/*
 * @Description:
 * @Version: 2.0
 * @Author: liangdengke
 * @Date: 2022-07-09 10:04:54
 * @LastEditors: your Name
 * @LastEditTime: 2022-08-29 16:50:42
 */
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user.js";
// import inquireList from "./modules/inquireList.js";
// import eTicket from "./modules/eTicket.js";
 import financialPlan from "./modules/financialPlan.js";
 import insurance from "./modules/insurance.js";
// import contract from "./modules/contract.js";
import { recordPushDataFn } from "@/serves/buryingPoint.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    commonData: [],
    insuranceId: "",
    recordId: "",
    buryingPointData: { //埋点固定数据 TODO模拟数据
      // classId: "",
      // clientId: "1349883712819110000",
      // courseId: "",
      // examPlan: "5000000712",
      // examType: "6",
      // lang: "null",
      // orgId: "1",
      // paperCode: "cdefcc64-b1ae-4077-b143-ba9905242195",
      // platform: "bigdataenterprisecreditOS",
      // questionId: "201805",
      //questionCode:"201805",
      // roleCode: "bank2",
      // sign: "aa10fc0dbeb45285e2857d9613238894",
      // sourceId: "6_NONE_NONE_5000000712_71251000327561010_NONE",
      // teamId: "71251000327561010",
      // timestamp: "1661334180000",
      // token: "a9c4d05b-150f-4c0f-8595-d399118a4a00",
      // userCode: "85740",
    }
  },
  getters: {
    commonData: state => state.commonData,
    insuranceId: state => state.insuranceId,
    recordId: state => state.recordId,
    buryingPointData: state => state.buryingPointData
  },
  mutations: {
    commonData: (state, commonData) => {
      Object.assign(state.commonData, commonData);
    },
    insuranceId: (state, insuranceId) => {
      Object.assign(state.insuranceId, insuranceId);
    },
    recordId: (state, recordId) => {
      Object.assign(state.recordId, recordId);
    },
    buryingPointData: (state, obj) => {
      Object.assign(state.buryingPointData, obj);
    },
    deleteFixedPointData: state => {
      if (state.buryingPointData.formName) delete state.buryingPointData.formName;
      if (state.buryingPointData.detailContent) delete state.buryingPointData.detailContent;
      if (state.buryingPointData.formMapper) delete state.buryingPointData.formMapper;
      if (state.buryingPointData.businessCode) delete state.buryingPointData.businessCode;
    }
  },
  actions: {
    //发送埋点信息
    recordPushData({ state }, data){
      let resData = Object.assign(data, state.buryingPointData);
      recordPushDataFn(resData).catch(() => {

      });
    }
  },
  modules: {
    user,
    financialPlan,
    insurance,

    // inquireList,
    // eTicket,
    // quota,
    // contract
  },
});
